type DivWithListener = {
  div: HTMLElement;
  controller: AbortController;
  preloaded: boolean;
};

export class BackgroundSwitcher {
  private imageDivs: DivWithListener[] = [];

  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    // this.handlePreloadImages();
  }

  bindEvents() {
    document.querySelectorAll<HTMLElement>('[data-bg-img]').forEach(el => {
      const controller = new AbortController();
      this.imageDivs.push({
        div: el,
        controller,
        preloaded: false,
      });

      el.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      el.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    });
  }

  handleMouseEnter(e: MouseEvent) {
    const el = e.currentTarget as HTMLElement;
    const target = el.parentNode?.parentNode?.querySelector<HTMLElement>('[data-bg-target]');
    if (!target) return;
    if (!el?.dataset?.index) return;
    const index = +el.dataset.index;
    target.querySelectorAll('img').forEach((img, idx) => {
      if(idx === index) {
        img.classList.add('img-visible');
      } else {
        img.classList.remove('img-visible');
      }
    });
  }

  handleMouseLeave(e: MouseEvent) {
    const el = e.currentTarget as HTMLElement;
    const target = el.parentNode?.parentNode?.querySelector<HTMLElement>('[data-bg-target]');
    if (!target) return;
    target.querySelectorAll('img').forEach((img, idx) => {
      if(idx === 0) {
        img.classList.add('img-visible');
      } else {
        img.classList.remove('img-visible');
      }
    });
  }

  handlePreloadImages() {
    const offset = 100;
    this.imageDivs.forEach(el => {
      window.addEventListener(
        'mousemove',
        (event: MouseEvent) => {
          const rect = el.div.getBoundingClientRect();
          const mouseX = event.clientX;
          const mouseY = event.clientY;
          if (mouseX > rect.left - offset && mouseX < rect.right + offset && mouseY > rect.top - offset && mouseY < rect.bottom + offset) {
            this.preloadImages(el);
            el.preloaded = true;
          }
        },
        { signal: el.controller.signal }
      );
    });
  }

  preloadImages(wrapper: DivWithListener) {
    if(wrapper.preloaded) return;

    const uri = wrapper.div.dataset.bgImg;
    if (!uri) return;

    const img = new Image();
    img.src = uri;
    img.onload = () => {
      wrapper.preloaded = true;
      wrapper.controller.abort();
    };
  }
}
